export const paymentsFeatureName = 'appnebula-payments';

export const paymentsFeatureDefaultValue = {
  card: true,
  paypal: true,
  apple_pay: true,
  google_pay: true,
};
